import React from 'react';
import { Row } from '../../../../../../ui';
import { DetailsFormSection as Section } from '../DetailsFormSection';
import { Password } from '../../../../../auth/shared/form-fields/Password';
import { ConfirmPassword } from '../../../../../auth/shared/form-fields/ConfirmPassword';
import { NewUserAccountCheckbox } from '../fields/NewUserAccountCheckbox';
import { useDetailsFormContext } from '../hooks/useDetailsFormContext';

export interface INewUserAccountFormData {
	shouldCreateNewUserAccount?: boolean;
	password?: string;
	confirmPassword?: string;
}

export const NewUserAccount = () => {
	const { watch } = useDetailsFormContext();

	const shouldCreateNewUserAccount = watch('shouldCreateNewUserAccount');

	return (
		<Section>
			<Row columns={1}>
				<NewUserAccountCheckbox />
			</Row>
			{shouldCreateNewUserAccount && (
				<Row>
					<Password validateConfirmation autoComplete="new-password" />
					<ConfirmPassword />
				</Row>
			)}
		</Section>
	);
};
